import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog'; // Import PrimeNG Dynamic Dialog services

@Component({
  selector: 'app-project-create-dialog',
  templateUrl: './project-create-dialog.component.html',
  styleUrls: ['./project-create-dialog.component.scss']
})
export class ProjectCreateDialogComponent implements OnInit {
  private fb = inject(FormBuilder);
  // Inject PrimeNG dialog services
  private dialogRef = inject(DynamicDialogRef);
  private config = inject(DynamicDialogConfig);

  projectForm!: FormGroup;
  isEditMode = false;

  ngOnInit(): void {
    // Check if we're in edit mode by looking for data in the config
    this.isEditMode = !!this.config.data;
    
    // Initialize the form with data if in edit mode
    this.projectForm = this.fb.group({
      name: [this.isEditMode ? this.config.data.name : '', Validators.required], // Name is required
      description: [this.isEditMode ? this.config.data.description : ''] // Description is optional
    });
  }

  onCancel(): void {
    // Close the dialog using PrimeNG's close method
    this.dialogRef.close();
  }

  onSave(): void {
    // Check if the form is valid
    if (this.projectForm.valid) {
      // Close the dialog and pass the form value using PrimeNG's close method
      this.dialogRef.close(this.projectForm.value);
    }
  }
}
